import React, { useEffect } from 'react';

import { useBeam } from "@randajan/bifrost/client/react";
import { LoginButton } from "./LoginButton/LoginButton"
import { ProfileButton } from "./ProfileButton/ProfileButton"
import { meBeam } from "../../assets/beams/meBeam";
import { usePop } from '@randajan/jet-react/dom/modal';
import { Medailon } from './Medailon/Medailon';




export const User = (props) => {
    const { onLogin, onProfile } = props;
    const { data: user } = useBeam(meBeam);

    const initPop = usePop({ lock: true });

    // useEffect(_ => {
    //     if (!user) { initPop.down(); return; }
    //     const { consentTerms, consentGdpr, consentNotify } = user;
    //     if (consentTerms && consentGdpr && consentNotify != null) { initPop.down(); return; }
    //     initPop.up(<InitScreen onFinish={_=>initPop.down()}/>);
    // }, [user]);

    return user ? <ProfileButton onClick={onProfile}><Medailon {...user}/></ProfileButton> : <LoginButton onClick={onLogin}/>;
}
